import { useState } from 'react';
import { ContactFormData } from '../models';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import contactService from '../services/contactService';
import { useNavigate } from 'react-router-dom';
import './Common.scss';

export default function ContactPage() {
  const [form, setForm] = useState<ContactFormData>({
    name: '',
    email: '',
    message: '',
  });
  const navigate = useNavigate();

  const handleSubmit = async () => {
    await contactService.createContact(form);
    navigate('/success?type=contact');
  };

  return (
    <Container fluid>
      <h2 className="mb-4 text-center text-success white-stroke">
        お問い合わせ
      </h2>
      <Row className="justify-content-center min-vh-100 g-0">
        <Col lg={8} md={8} sm={10} xs={12} className="mb-4">
          <Form>
            <Form.Group className="mb-3" controlId="contactName">
              <Form.Label className="text-success white-stroke">
                お名前
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="お名前"
                onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="contactEmail">
              <Form.Label className="text-success white-stroke">
                メール
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="メール"
                onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="contactMessage">
              <Form.Label className="text-success white-stroke">
                内容
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="内容"
                onChange={e =>
                  setForm(f => ({ ...f, message: e.target.value }))
                }
              />
            </Form.Group>
            <div className="text-center">
              <Button variant="success" onClick={handleSubmit}>
                送信
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}
